import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import './style.css';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const SpinnerOverlay = ({ show }: { show: boolean }) => {
  if (!show) return null;
  return (
    <div className="spinner-overlay-container">
      <Spin indicator={antIcon} />;
    </div>
  );
};

export default SpinnerOverlay;
